import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function SocialMediaManagement() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Expand Your Reach with Strategic Social Media Marketing
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We go beyond standard social media tactics. Our structured
                approach strengthens brand presence and attracts engaged
                audiences. We optimize every campaign to increase visibility and
                drive meaningful interactions.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Targeted Strategies"
                  subtitle1="Reach the right audience at the right time."
                  title2="Performance-Optimized"
                  subtitle2="Maximize ROI with data-driven campaigns."
                  title3="Effortless Management"
                  subtitle3="Simplify and scale your marketing efforts."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                Social Media Marketing Services for Stronger Engagement and
                Higher Conversions
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we execute social media strategies that
                drive measurable engagement.
                <br />
                <ul>
                  {" "}
                  <li>
                    <b>
                      Handles content creation and audience targeting to improve
                      brand visibility.
                    </b>
                  </li>
                  <li>
                    <b>
                      Reaches the right users and builds meaningful connections.
                    </b>
                  </li>
                  <li>
                    <b>
                      Strengthens customer interaction and enriches brand
                      loyalty.
                    </b>
                  </li>
                </ul>
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/smm.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <OurProcess
            process={"Our Social Media Marketing Services"}
            invert={!dark}
            step1={"Audience Research and Targeting"}
            step1description={
              "We analyze customer demographics and behavioral insights. Our team identifies high-intent users and refines targeting parameters. We also optimize content for specific audience segments."
            }
            step2={"Content Strategy and Social Posting"}
            step2description={
              "We develop platform-specific content that seamlessly matches with brand objectives. Our team schedules posts strategically and optimizes content formats. We also refine messaging to improve engagement and audience retention."
            }
            step3={"Community Engagement and Brand Awareness"}
            step3description={
              "We interact with followers and respond to customer queries. Our team builds meaningful conversations and strengthens brand loyalty. We also track audience sentiment to refine engagement tactics."
            }
            step4={"Paid Advertising and Campaign Management"}
            step4description={
              "We create targeted ad campaigns that drive traffic and lead generation. Our team optimizes ad placements and adjusts bidding strategies. We also refine creatives to improve click-through rates."
            }
          />
          <Advantages
            invert={!dark}
            title={
              "Advantages of Social Media Marketing Services For Businesses"
            }
            title1={"Stronger Brand Awareness"}
            subtitle1={
              "We optimize social presence to increase visibility across multiple platforms. This improves brand recognition and attracts more engaged users."
            }
            title2={"Higher Engagement Rates"}
            subtitle2={
              "We develop interactive content that resonates with audiences. This approach strengthens customer relationships and improves retention."
            }
            title3={"Sustainable Growth"}
            subtitle3={
              "We implement audience-building strategies that drive long-term engagement. Our methods align with social media trends and platform algorithms."
            }
            title4={"Improved Lead Generation"}
            subtitle4={
              "We develop targeted campaigns that drive traffic and increase conversions. Precise audience segmentation improves ad performance and return on investment."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={
              <h2>
                Our Passion is Elevating Your Brand and Strengthening Customer
                Connections
              </h2>
            }
            subtitle="At Riches Media Digital, we focus on expanding your brand reach and driving customer engagement.  
                social media marketing
            (SMM) levels up brand credibility by nurturing direct interactions with your audience. Notably, over 83% of marketers have identified increased exposure as a leading benefit of 
                social media marketing
             . Our approach involves audience research and content strategy. "
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/smm2.webp")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Social Media Marketing Services Will You Get"}
            invert={!dark}
            title1={"Targeted Social Media Strategies"}
            title2={"Data-Driven Audience Research"}
            title3={"High-Quality Content Development"}
            title4={"Proven Engagement Tactics"}
            title5={"Real-Time Campaign Optimization"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is Social Media Marketing?"
            a1="  <a href='https://richesmediadigital.com/social-media-management/'>
                social media marketing
              </a>(SMM) promotes brands through digital platforms. It involves content creation and <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a>. We further refine targeting strategies to increase brand visibility and customer interaction."
            q2="Why is SMM important for my business?"
            a2="SMM strengthens brand presence and improves customer engagement. A well-optimized strategy attracts loyal audiences and drives conversions. Businesses that invest in SMM enhance customer trust and increase long-term <a href='https://richesmediadigital.com/branding/'>
                brand awareness
              </a>."
            q3="How long does it take to see results from SMM?"
            a3="SMM delivers engagement improvements within weeks. Lead generation and <a href='https://richesmediadigital.com/branding/'>
                brand awareness
              </a> increase over time based on audience growth and campaign effectiveness. Continuous optimization strengthens results and improves performance."
            q4="What platforms do you specialize in for SMM?"
            a4="We manage campaigns across Facebook and Instagram. We also optimize content for LinkedIn and Twitter. Each platform is handled with unique strategies to maximize engagement and reach."
            q5="How to create content that resonates with audiences?"
            a5="We conduct audience research and analyze engagement trends. Our team develops content that aligns with user interests and brand messaging. Testing different formats improves interaction and strengthens content strategy."
            q6="How can I measure the success of my SMM campaigns?"
            a6="SMM success is measured through engagement rates and lead conversions. We track social impressions and interaction metrics. Regular performance reports highlight growth and areas for improvement."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
